exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"menuText": "#000",
	"menuActiveText": "#f0426c",
	"subMenuActiveText": "#f0426c",
	"menuBg": "#fff",
	"menuHover": "#fdecf0",
	"subMenuBg": "#fff",
	"subMenuHover": "#fdecf0",
	"sideBarWidth": "3.2rem"
};